import { createFileRoute } from "@tanstack/react-router";
import { NeuralPage } from "../features/neural/NeuralPage";

// TANK Neural in a workspace (Robby, 2026-11-01): the /ai chat inside the workspace, its own
// section, private to each person. `?c=` names the open conversation.
export const Route = createFileRoute("/w/$ws/neural")({
  validateSearch: (s: Record<string, unknown>): { c?: string } =>
    typeof s.c === "string" && s.c ? { c: s.c } : {},
  component: NeuralPage,
});
